import { HttpParams } from '@angular/common/http';

export const appendParams = (key: string, ids: any[], params = new HttpParams()): HttpParams =>
	ids.reduce((p: HttpParams, id: any) => p.append(key, id), params);
